<mat-accordion>

    <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Ação da Reunião {{reuniao.tema}}
            </mat-panel-title>
        </mat-expansion-panel-header>

        <cadastrar-acoes-reuniao #cadastrarAcoes [reuniao]="reuniao" (onAbertoFormAdicaoAcaoReuniao)="onGetAdicionar($event)">
        </cadastrar-acoes-reuniao>
    </mat-expansion-panel>


    <mat-expansion-panel [expanded]="!openFormCadastro"
                         (opened)="listarAcoes.carregarLista()"
                         (closed)="openFormCadastro = true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Lista de Ações ( {{reuniao.acoesReuniao?.length}} )
            </mat-panel-title>
        </mat-expansion-panel-header>

        <listar-acoes-reuniao #listarAcoes
            [acoesReuniao]="reuniao.acoesReuniao"
            (onAtualizarAcao)="onGetAdicionar($event); cadastrarAcoes.atualizarAcao($event)"
            (onAbertoFormAdicaoAcaoReuniao)="onGetAdicionar($event); cadastrarAcoes.iniciarObjetos()">
        </listar-acoes-reuniao>

    </mat-expansion-panel>

</mat-accordion>